import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';
import { BottomPanelComponent } from './components/bottom-panel/bottom-panel.component';
import { SharedModule } from '../shared/shared.module';
import { ResizableModule } from 'angular-resizable-element';
import { TranslateModule } from '@ngx-translate/core';
import { FormControlsModule } from '../component/detail-view/form-controls/form-controls.module';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { AgGridListViewComponent } from './components/ag-grid-list-view/ag-grid-list-view.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AgGridServerSideComponent } from './components/ag-grid-server-side/ag-grid-server-side.component';
import { CsvExportModule } from './components/csv-export-button/csv-export.module';

@NgModule({
  declarations: [BottomPanelComponent, AgGridListViewComponent, AgGridServerSideComponent],
  imports: [
    CommonModule,
    SharedModule,
    ResizableModule,
    TranslateModule,
    FormControlsModule,
    CollapseModule.forRoot(),
    TabsModule,
    CsvExportModule,
  ],
  providers: [DecimalPipe, CurrencyPipe],
  exports: [BottomPanelComponent],
})
export class BottomPanelModule {}
